import { Spin } from "antd";

const Loader = () => {
  return (
    <div className="flex-center">
      <Spin />
    </div>
  );
};

export default Loader;
